import { lazy } from "react";

export type { IGifPreferencePopupProps } from "./types";

export const GifPreferencePopup = lazy(() => import("./GifPreferencePopup"));
